import { SB } from '@play-co/replicant';
import { getLocaleConfig } from 'src/replicant/creatives/text';
import { tuple } from 'src/replicant/utils/types';
import {
  getPetAssetKey,
  speciesAssetsRatio,
  speciesChatbot,
  SpeciesType,
} from './species';
import {
  createFlexMessageTemplate,
  createFlexContainer,
  createOpenGameAction,
} from './utils';
import { buildSender } from '../sender';

/**
 * Assets for daycare messages
 */
export const daycareAssets = {
  'background/daycare/finish':
    'private/chatbot/daycare/daycare_finished_background.png',
};

/**
 * Create daycare message
 *
 * https://developers.line.biz/en/docs/messaging-api/flex-message-elements/
 * https://developers.line.biz/en/docs/messaging-api/using-flex-messages/
 *
 * Tools for generation of messages in flex format:
 * https://developers.line.biz/flex-simulator/
 */
export const daycareMessage = createFlexMessageTemplate(
  SB.object({
    species: SB.tuple(speciesChatbot),
    locale: SB.tuple(['en', 'ja']),
    petName: SB.string(),
  }),
  (data, payload, api) => {
    const altText = getLocaleConfig(data.locale).daycare.finish.text;
    const normal = api.getAssetPath(getPetAssetKey(data.species));

    const template = createFlexContainer(altText, {
      type: 'bubble',
      size: 'giga',
      action: createOpenGameAction(altText, payload),
      body: {
        type: 'box',
        layout: 'vertical',
        contents: [
          {
            type: 'image',
            url: api.getAssetPath(`background/daycare/finish`),
            size: 'full',
            aspectMode: 'cover',
            aspectRatio: '1.51:1',
            gravity: 'center',
          },
          {
            type: 'box',
            layout: 'vertical',
            position: 'absolute',
            width: '100%',
            height: '100%',
            offsetBottom: '30%',
            alignItems: 'center',
            justifyContent: 'flex-end',
            contents: [
              {
                type: 'box',
                layout: 'vertical',
                contents: [
                  {
                    type: 'image',
                    url: normal,
                    aspectRatio: '286:213', // Use fixed aspect ratio for pet icon.
                    size: 'full',
                  },
                ],
                width: '45%',
                height: '55%',
              },
            ],
          },
        ],
        paddingAll: '0px',
      },
    });

    // Add sender to message
    template['sender'] = buildSender({ name: data.petName, iconUrl: normal });

    return template;
  },
);
